import { ChipsideComponent } from "../chipside-component";

export class ProgressItem extends ChipsideComponent {
	constructor() {
		super();

		this.active = this.hasAttribute("active");
	}

	parsedCallback() {
		this.prepend(document.createElementWithContents("div", null, { className: "progress-item__icon" }));
	}
}